import 'regenerator-runtime/runtime';
import Vue from 'vue';

import BulmaCollapsible, { bulmaCollapsible } from '@creativebulma/bulma-collapsible';
import Swiper from 'swiper';
import './form';

import {
  Mousewheel,
  Pagination,
  Navigation,
  Autoplay,
  EffectCards
} from 'swiper/modules';


import SocialShare from './components/SocialShare.vue';
import Carousel from './components/Carousel.vue';
import Calculator from './components/Calculator.vue';
import ProductSteps from './components/ProductSteps.vue';
import VeloService from './components/VeloService.vue';
import Map from './components/Map.vue';
import Quiz from './components/Quiz.vue';
import DigitalAssistance from './components/DigitalAssistance.vue';
import CourseBooking from './components/CourseBooking.vue';
import PriceConfigurator from './components/PriceConfigurator.vue';
import Linkout from './components/Linkout.vue';
import './plugins/v-calendar';

import Tabs from './modules/Tabs';
import Logo from './modules/Logo';
import Offcanvas from './modules/Offcanvas';
import SliderSnippets from './modules/SliderSnippets';
import ProductGallery from './modules/ProductGallery';
import FloatingButtons from './modules/FloatingButtons';
import GrowingBox from './modules/GrowingBox';
import Sweepstake from './modules/Sweepstake';
import Modal from './modules/Modal';
import ReadMore from './modules/ReadMore';
import EcommerceForm from './modules/EcommerceForm';
import QuickNavigation from './modules/QuickNavigation';
import ReadingProgress from './modules/ReadingProgress';
import ScrollToTop from './modules/ScrollToTop';
import Animation from './modules/Animation';
import OrderForm from './modules/OrderForm';
import AnimatedCounter from './modules/AnimatedCounter';
import MoreLoad from './modules/MoreLoad';
import NavMobileMenu from './modules/NavMobileMenu';
import ImageSwitcher from "./modules/ImageSwitcher";

// Scrollytelling components
import ScrollytellingHorizontal from './scrollytelling/ScrollytellingHorizontal';
import ScrollytellingHearts from './scrollytelling/ScrollytellingHearts';
import ScrollytellingCards from './scrollytelling/ScrollytellingCards';
import ScrollytellingWord from './scrollytelling/ScrollytellingWord';
import Iframe from './modules/Iframe';
import PDFViewer from './modules/PDFViewer';
import MarqueeSlider from './modules/MarqueeSlider';
import YoutubePlayer from './modules/YoutubePlayer';
import MobileSlider from './modules/MobileSlider';
import ImageTabs from './modules/ImageTabs';
import RoadTrip from './modules/RoadTrip';
import FlipCards from './modules/FlipCards';

Offcanvas.init();
SliderSnippets.init();
ProductGallery.init();
FloatingButtons.init();
GrowingBox.init();
Logo.init();
Modal.init();
Sweepstake.init();
EcommerceForm.init();
QuickNavigation.init();
ReadMore.init();
ReadingProgress.init();
ScrollToTop.init();
Animation.init();
new AnimatedCounter();

ScrollytellingHorizontal.init();
ScrollytellingHearts.init();
ScrollytellingCards.init();
ScrollytellingWord.init();
Iframe.init();
PDFViewer.init();
MoreLoad.init();
NavMobileMenu.init();
ImageSwitcher.init();
MarqueeSlider.init();
YoutubePlayer.init();
MobileSlider.init();
ImageTabs.init();
RoadTrip.init();
FlipCards.init();

let carouselList = document.querySelectorAll('.js-vue-carousel');

if (carouselList.length) {
  carouselList.forEach(function (el) {
    new Vue({
      el: el,
      delimiters: ['<%', '%>'],
      components: {
        'nfx-carousel': Carousel,
      },
    });
  });
}

let shareList = document.querySelectorAll('.js-vue-share');

if (shareList.length) {
  shareList.forEach(function (el) {
    new Vue({
      el: el,
      components: {
        'nfx-share': SocialShare
      }
    })
  });
}


let linkoutList = document.querySelectorAll('.js-vue-linkout');

if (linkoutList.length) {
  linkoutList.forEach(function (el) {
    new Vue({
      el: el,
      components: {
        'nfx-linkout': Linkout
      }
    })
  });
}

let veloServiceContainer = document.querySelector('.js-vue-velo-service');

if (veloServiceContainer) {
  new Vue({
    el: veloServiceContainer,
    delimiters: ['<%', '%>'],
    components: {
      'nfx-velo-service': VeloService,
    },
  });
}

let calculatorContainer = document.querySelector('.js-vue-calculator');

if (calculatorContainer) {
  new Vue({
    el: calculatorContainer,
    delimiters: ['<%', '%>'],
    components: {
      'nfx-calculator': Calculator,
    },
  });
}

let productStepsContainer = document.querySelector('.js-vue-product-steps');

if (productStepsContainer) {
  new Vue({
    el: productStepsContainer,
    delimiters: ['<%', '%>'],
    components: {
      'nfx-product-steps': ProductSteps,
    },
  });
}

let mapContainer = document.querySelector('.js-vue-map');

if (mapContainer) {
  new Vue({
    el: mapContainer,
    delimiters: ['<%', '%>'],
    components: {
      'nfx-map': Map,
    },
  });
}

let digitalAssistanceContainer = document.querySelector('.js-vue-digital-assistance');
if (digitalAssistanceContainer) {
  console.log(digitalAssistanceContainer);

  new Vue({
    el: digitalAssistanceContainer,
    delimiters: ['<%', '%>'],
    components: {
      'nfx-digital-assistance': DigitalAssistance,
    },
  });
}

let quizContainer = document.querySelector('.js-vue-quiz');

if (quizContainer) {
  new Vue({
    el: quizContainer,
    delimiters: ['<%', '%>'],
    components: {
      'nfx-quiz': Quiz,
    },
  });
}

let CourseBookingContainer = document.querySelector('.js-vue-course-booking');

if (CourseBookingContainer) {
  new Vue({
    el: CourseBookingContainer,
    delimiters: ['<%', '%>'],
    components: {
      'nfx-course-booking': CourseBooking,
    },
  });
}

let priceConfiguratorContainer = document.querySelector('.js-vue-price-configurator');

if (priceConfiguratorContainer) {
  new Vue({
    el: priceConfiguratorContainer,
    delimiters: ['<%', '%>'],
    components: {
      'nfx-price-configurator': PriceConfigurator,
    },
  });
}

BulmaCollapsible.attach('.is-collapsible');

function initSliders() {
  const sliderList = document.querySelectorAll('.js-slider');
  const sliderTabList = document.querySelectorAll('.js-slider-tab');

  if (sliderList.length) {
    sliderList.forEach((currentSlider) => {
      if (currentSlider.swiper) {
        currentSlider.swiper.destroy();
      }

      let options = JSON.parse(currentSlider.dataset.options || '{}');

      if (Object.keys(options).length === 0) {
        options = {
          mousewheel: {
            forceToAxis: true,
          },
          loop: true,
          navigation: {
            nextEl:
              currentSlider.dataset.sliderElementNext || '.swiper-button-next',
            prevEl:
              currentSlider.dataset.sliderElementPrev || '.swiper-button-prev',
          },
          pagination: {
            el:
              currentSlider.dataset.sliderElementPagination ||
              '.swiper-pagination',
            clickable: true,
          },
          observer: true,
          slidesPerView: currentSlider.dataset.slides || 1,
          spaceBetween: parseInt(currentSlider.dataset.sliderSpaceBetween || 0),
          centeredSlides: currentSlider.dataset.sliderCenteredSlides
            ? currentSlider.dataset.sliderCenteredSlides === 'true'
            : false,
          breakpoints: {
            0: {
              slidesPerView: 1,
            },
            768: {
              slidesPerView: currentSlider.dataset.slides || 1,
            },
          },
        };
      }

      if (currentSlider.dataset.hasOwnProperty('sliderAutoplay')) {
        options.autoplay = {
          delay: 5000,
          disableOnInteraction: true,
        };
      }

      if (currentSlider.dataset.hasOwnProperty('sliderEffect')) {
        options.effect = currentSlider.dataset.sliderEffect;

        if (options.effect === 'cards') {
          options.grabCursor = true;
          options.cardsEffect = {
            slideShadows: false,
          };
        }
      }

      if (currentSlider.dataset.hasOwnProperty('showSlidesPreview')) {
        options.breakpoints = {
          0: {
            slidesPerView: 1.3,
            centeredSlides: true,
            spaceBetween: 15,
            autoHeight: false,
          },
          768: {
            slidesPerView: currentSlider.dataset.slides || 1,
          },
        };
        currentSlider.addEventListener('click', function (e) {
          if (e.target.closest('.swiper-slide-prev')) {
            currentSlider.navigating = true;
            window.setTimeout(function () {
              currentSlider.navigating = false;
            }, 50);
            currentSlider.swiper.slidePrev();
          }
          if (e.target.closest('.swiper-slide-next')) {
            currentSlider.navigating = true;
            window.setTimeout(function () {
              currentSlider.navigating = false;
            }, 50);
            currentSlider.swiper.slideNext();
          }
        });
      }

      if (currentSlider.dataset.hasOwnProperty('showRightSlidePreview')) {
        options.breakpoints = {
          0: {
            slidesPerView: 'auto',
            spaceBetween: 15,
            autoHeight: false,
            width: '90%',
          },
          768: {
            slidesPerView: currentSlider.dataset.slides || 1,
          },
        };
        currentSlider.addEventListener('click', function (e) {
          if (e.target.closest('.swiper-slide-prev')) {
            currentSlider.navigating = true;
            window.setTimeout(function () {
              currentSlider.navigating = false;
            }, 50);
            currentSlider.swiper.slidePrev();
          }
          if (e.target.closest('.swiper-slide-next')) {
            currentSlider.navigating = true;
            window.setTimeout(function () {
              currentSlider.navigating = false;
            }, 50);
            currentSlider.swiper.slideNext();
          }
        });
      }

      if (
        currentSlider.dataset.hasOwnProperty('sliderNoLoop') &&
        currentSlider.dataset.hasOwnProperty('showRightSlidePreview')
      ) {
        options = {
          slidesPerView: 'auto',
          spaceBetween: 15,
          loop: false,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
        };
      }

      if (currentSlider.dataset.hasOwnProperty('desktopSlider')) {
        options = {
          slidesPerView: 3,
          spaceBetween: 20,
          loop: true,
          navigation: {
            nextEl:
              currentSlider.dataset.sliderElementNext || '.swiper-button-next',
            prevEl:
              currentSlider.dataset.sliderElementPrev || '.swiper-button-prev',
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
        };
      }

      const agent = navigator.userAgent;
      const iosVersion16 = 'iPhone OS 16';
      const iosVersion15 = 'iPhone OS 15';
      let isIphone = false;
      if (
        (agent.includes(iosVersion15) || agent.includes(iosVersion16)) &&
        window.document.documentElement.clientWidth < 768
      ) {
        isIphone = true;
      }

      if (!currentSlider.dataset.hasOwnProperty('sliderAutoplay') && isIphone) {
        options.autoHeight = true;
      }

      if (currentSlider.dataset.hasOwnProperty('sliderNoLoop')) {
        options.loop = false;
      }

      options.modules = [Mousewheel, Navigation, Pagination, Autoplay, EffectCards];
      //Swiper.use([Mousewheel, Navigation, Pagination, Autoplay, EffectCards]);

      const swiper = new Swiper(currentSlider, options);
      let lastModule;
      let lastSection;

      swiper.on('slideChange', function (swiper) {
        if (swiper.autoplay && swiper.autoplay.running) {
          return;
        }
        const parents = getParents(swiper.el, '[data-module]');
        let path = '';

        if (parents.length > 0) {
          parents.reverse();
          path = parents.map((parent) => parent.dataset.module).join(' > ');
        }

        if (
          (lastModule ===
            path + ' > Slider > Slide ' + (swiper.realIndex + 1) &&
            lastSection ===
              swiper.el.closest('section[id],header[id],footer[id]').id) ||
          ''
        ) {
          return;
        }
        lastSection =
          swiper.el.closest('section[id],header[id],footer[id]').id || '';
        lastModule = path + ' > Slider > Slide ' + (swiper.realIndex + 1);

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'nfx_event',
          event_section:
            swiper.el.closest('section[id],header[id],footer[id]').id || '',
          event_modul: path + ' > Slider > Slide ' + (swiper.realIndex + 1),
          event_element: 'slide-change',
          event_thema: swiper.el.closest('[data-event-topic]')
            ? swiper.el.closest('[data-event-topic]').dataset.eventTopic
            : '',
          event_klicktext: '',
        });
      });

      if (isIphone) {
        window.setTimeout(function () {
          swiper.updateAutoHeight();
          console.log('IOS detected and swiper updated');
        }, 3000);
      }

      if (
        sliderTabList.length &&
        currentSlider.classList.contains('has-tabs')
      ) {
        const sliderTabListArr = [...sliderTabList];
        for (const [index, tab] of sliderTabListArr.entries()) {
          let realIndex = index;

          tab.addEventListener('click', function (event) {
            swiper.slideToLoop(realIndex);
          });
        }

        swiper.on('slideChange', function (swiper) {
          const swiperIndex = swiper.realIndex;
          const sliderTab = document.querySelector(
            '.js-slider-tab[data-tab="' + swiperIndex + '"]'
          );
          sliderTabList.forEach((sliderTab) =>
            sliderTab.classList.remove('is-active')
          );
          sliderTab.classList.add('is-active');
        });
      }
    });
  }
}

initSliders();

window.initSliders = initSliders;

Tabs.init();

const snippetContainers = document.querySelectorAll(
  '.pimcore_area_horizontal-snippets'
);

if (snippetContainers.length) {
  snippetContainers.forEach(function (container) {
    container.addEventListener('click', function (e) {
      const sliderContainer = container.querySelectorAll('.js-slider');
      if (
        sliderContainer.length &&
        window.document.documentElement.clientWidth < 768
      ) {
        if (e.target.matches('.swiper-slide-active [data-slide-trigger]')) {
          const currentSlider = e.target.closest('.js-slider');
          if (!currentSlider.navigating) {
            e.target.closest('[data-slide]').classList.toggle('is-open');
          }
        }
      } else {
        if (e.target.matches('[data-slide-trigger]')) {
          e.target.closest('[data-slide]').classList.toggle('is-open');
        }
      }
    });
  });

  function setSameHeight() {
    let maxHeight = 0;
    for (let i = 0; i < snippetContainers.length; i++) {
      let slideHeadings = snippetContainers[i].querySelectorAll(
        '.slide-overlay .slide-heading > div:first-child'
      );
      maxHeight = 0;
      for (let j = 0; j < slideHeadings.length; j++) {
        if (slideHeadings[j].offsetHeight > maxHeight) {
          maxHeight = slideHeadings[j].offsetHeight;
        }
      }
      for (let j = 0; j < slideHeadings.length; j++) {
        slideHeadings[j].style.height = maxHeight + 'px';
      }
    }
  }
  setSameHeight();

  function setSameHeightHelper() {
    let maxHeight = 0;
    for (let i = 0; i < snippetContainers.length; i++) {
      let slideOverlays =
        snippetContainers[i].querySelectorAll('.slide-overlay');
      let slideHelpers = snippetContainers[i].querySelectorAll(
        '.slide-height-helper'
      );
      maxHeight = 0;
      for (let j = 0; j < slideOverlays.length; j++) {
        if (slideOverlays[j].offsetHeight > maxHeight) {
          maxHeight = slideOverlays[j].offsetHeight + 22;
        }
      }
      for (let j = 0; j < slideOverlays.length; j++) {
        slideOverlays[j].style.height = maxHeight + 'px';
        slideHelpers[j].style.height = maxHeight + 'px';
      }
    }
  }
  setSameHeightHelper();
}

function getParents(el, parentSelector) {
  if (parentSelector === undefined) {
    parentSelector = document;
  }
  var parents = [];
  var p = el.parentNode;
  while (p !== document) {
    var o = p;
    if (p.matches(parentSelector)) {
      parents.push(o);
    }
    p = o.parentNode;
  }

  return parents;
}

const flags = document.querySelectorAll('.tabbed-flags');

if (flags.length) {
  document.addEventListener('click', function (event) {
    if (event.target.dataset.modal) {
      flags.forEach((flag) => flag.classList.add('is-hidden'));
    }
  });

  document.addEventListener('click', function (event) {
    if (event.target.classList.contains('modal-close')) {
      flags.forEach((flag) => flag.classList.remove('is-hidden'));
    }
  });
}

const quickNaviWithoutArrows = document.querySelectorAll(
  '.tab-navigation-item-without-arrows'
);
const html = document.getElementsByTagName('html');

if (quickNaviWithoutArrows.length) {
  html[0].classList.add('quick-navi-scroll-padding');
}

// Show a few Accordion Elements for Mobile & Tablet
const accordionContainer = document.querySelectorAll(
  '.js-mobile-pre-collapsed.collapsible-container'
);

if (accordionContainer.length) {
  if (window.document.documentElement.clientWidth < 769) {
    accordionContainer.forEach((container) => {
      const accordionShowMore = container.querySelector(
        '.js-accordion-show-more'
      );
      const accordionShowLess = container.querySelector(
        '.js-accordion-show-less'
      );
      const collapsibleList = container.querySelectorAll(
        '.js-mobile-pre-collapsed.collapsible-container > .collapsible'
      );
      const amountOfElements = container.dataset.shownAmount;

      const collapsibleListArr = [...collapsibleList];

      for (let index = 0; index < collapsibleListArr.length; ++index) {
        const element = collapsibleListArr[index];
        if (index >= amountOfElements) {
          element.classList.add('is-hidden');
        }
      }

      accordionShowMore.addEventListener('click', function (event) {
        for (let index = 0; index < collapsibleListArr.length; ++index) {
          const element = collapsibleListArr[index];

          if (index >= amountOfElements) {
            element.classList.remove('is-hidden');
          }
        }

        accordionShowMore.classList.add('is-hidden');
        accordionShowLess.classList.remove('is-hidden');
      });

      accordionShowLess.addEventListener('click', function (event) {
        for (let index = 0; index < collapsibleListArr.length; ++index) {
          const element = collapsibleListArr[index];

          if (index >= amountOfElements) {
            element.classList.add('is-hidden');
          }
        }

        accordionShowMore.classList.remove('is-hidden');
        accordionShowLess.classList.add('is-hidden');
      });
    });
  }
}

// Show a few Accordion Elements for Desktop
const accordionContainerDesktop = document.querySelectorAll(
  '.js-desktop-pre-collapsed.collapsible-container'
);

if (accordionContainerDesktop.length) {
  if (window.document.documentElement.clientWidth > 768) {
    accordionContainerDesktop.forEach((container) => {
      const accordionShowMoreDesktop = container.querySelector(
        '.js-accordion-show-more-desktop'
      );
      const accordionShowLessDesktop = container.querySelector(
        '.js-accordion-show-less-desktop'
      );
      const collapsibleListDesktop = container.querySelectorAll(
        '.js-desktop-pre-collapsed.collapsible-container > .collapsible'
      );
      const amountOfElementsDesktop = container.dataset.shownAmountDesktop;

      const collapsibleListArrDesktop = [...collapsibleListDesktop];

      for (let index = 0; index < collapsibleListArrDesktop.length; ++index) {
        const element = collapsibleListArrDesktop[index];
        if (index >= amountOfElementsDesktop) {
          element.classList.add('is-hidden');
        }
      }

      accordionShowMoreDesktop.addEventListener('click', function (event) {
        for (let index = 0; index < collapsibleListArrDesktop.length; ++index) {
          const element = collapsibleListArrDesktop[index];

          if (index >= amountOfElementsDesktop) {
            element.classList.remove('is-hidden');
          }
        }

        accordionShowMoreDesktop.classList.add('is-hidden');
        accordionShowLessDesktop.classList.remove('is-hidden');
      });

      accordionShowLessDesktop.addEventListener('click', function (event) {
        for (let index = 0; index < collapsibleListArrDesktop.length; ++index) {
          const element = collapsibleListArrDesktop[index];

          if (index >= amountOfElementsDesktop) {
            element.classList.add('is-hidden');
          }
        }

        accordionShowMoreDesktop.classList.remove('is-hidden');
        accordionShowLessDesktop.classList.add('is-hidden');
      });
    });
  }
}

// Show a few List Elements
const listContainer = document.querySelectorAll(
  '.js-mobile-pre-collapsed.js-collapsible-list'
);

if (listContainer.length) {
  listContainer.forEach((container) => {
    const listShowMore = container.querySelector('.js-list-show-more');
    const listShowLess = container.querySelector('.js-list-show-less');
    const collapsibleListItems = container.querySelectorAll(
      '.js-mobile-pre-collapsed.js-collapsible-list > .list-item'
    );
    const amountOfElements = container.dataset.shownAmount;

    const collapsibleListItemsArr = [...collapsibleListItems];

    for (let index = 0; index < collapsibleListItemsArr.length; ++index) {
      const element = collapsibleListItemsArr[index];
      if (index >= amountOfElements) {
        element.classList.add('is-hidden');
      }
    }

    listShowMore.addEventListener('click', function (event) {
      for (let index = 0; index < collapsibleListItemsArr.length; ++index) {
        const element = collapsibleListItemsArr[index];

        if (index >= amountOfElements) {
          element.classList.remove('is-hidden');
        }
      }

      listShowMore.classList.add('is-hidden');
      listShowLess.classList.remove('is-hidden');
    });

    listShowLess.addEventListener('click', function (event) {
      for (let index = 0; index < collapsibleListItemsArr.length; ++index) {
        const element = collapsibleListItemsArr[index];

        if (index >= amountOfElements) {
          element.classList.add('is-hidden');
        }
      }

      listShowMore.classList.remove('is-hidden');
      listShowLess.classList.add('is-hidden');
    });
  });
}

// B2B Insurances Section - Sync both Desktop Show / Hide Buttons
const accordionShowMoreDesktopAll = document.querySelectorAll(
  '.insurances-section .js-list-show-more'
);
const accordionShowLessDesktopAll = document.querySelectorAll(
  '.insurances-section .js-list-show-less'
);

if (accordionShowMoreDesktopAll.length) {
  for (var i = 0; i < accordionShowMoreDesktopAll.length; i++) {
    accordionShowMoreDesktopAll[0].addEventListener('click', function (event) {
      accordionShowMoreDesktopAll[1].click();
    });
    accordionShowMoreDesktopAll[1].addEventListener('click', function (event) {
      accordionShowMoreDesktopAll[0].click();
    });
  }
  for (var j = 0; j < accordionShowLessDesktopAll.length; j++) {
    accordionShowLessDesktopAll[0].addEventListener('click', function (event) {
      accordionShowLessDesktopAll[1].click();
    });
    accordionShowLessDesktopAll[1].addEventListener('click', function (event) {
      accordionShowLessDesktopAll[0].click();
    });
  }
}

// social share
const nativeShare = document.querySelectorAll('.js-social-native-share');

//check if native share button is in document
if (nativeShare.length > 0) {

  try {
    //check if device can share
    if (navigator.share) {
      //add eventlistener to open native share
      nativeShare.forEach((share) => {
        share.addEventListener('click', () => {
          navigator
            .share({
              url: window.location.href,
            })
            .then(() => {
              console.log('successful share');
            })
            .catch((err) => {
              console.log(err);
            });
        });
      });
    } else {
      //if .share = undefined: dont show share button
      nativeShare.forEach((share) => {
        share.classList.add('is-hidden');
      });
    }
  } catch (err) {
    //if error: dont show share button
          nativeShare.forEach((share) => {
            share.classList.add('is-hidden');
          });
    console.error(err);
  }


}

// Accordeon for Box with two Columns
// Allows multiple .is-active and doesn't conflict with child-accordeons
const parentCollapsible = document.querySelectorAll('.js-parent-collabsible')
const parentCollapsibleContent = document.querySelectorAll('.js-parent-collabsible-content')

if (parentCollapsible.length > 0) {
  parentCollapsible.forEach(parent => {
    parent.addEventListener('click', (e) => {
      const target = e.currentTarget.dataset.target
      e.currentTarget.classList.toggle('is-active')
      if (parentCollapsibleContent.length > 0) {
        parentCollapsibleContent.forEach(content => {
          const id = content.id
          if (id == target) {

            // add height: auto after expand
            content.addEventListener('transitionend', () => {
              if (content.classList.contains('is-active')) {
                content.style.height = 'auto';
              }
              content.removeEventListener('transitionend', onTransitionEnd);
            });

            //check current state
            if (content.classList.contains('is-active')) {
              // Collapse
              content.style.height = '0px';
              content.classList.remove('is-active');

            } else {
              // Expand

              content.style.height = 'auto';
              const height = content.scrollHeight + 'px'; // get computed height
              content.style.height = '0px'; // set back to initial value
              content.style.overflow = 'hidden'

              // Trigger reflow, flush cached CSS
              content.offsetHeight; // eslint-disable-line no-unused-expressions

              content.classList.add('is-active');
              content.style.transition = 'height 300ms ease-in-out';
              content.style.height = height;

            }
          }
        })
      }
      })
  })
}

function initPricingCard(card) {
  if (card.dataset.pricingCardInit === '1') {
      return;
  }
  
  card.dataset.pricingCardInit = '1';

  var toggle = card.querySelector('.js-pricing-card-toggle');
  var hidden = card.querySelectorAll('.js-hidden-feature');

  if (!toggle || hidden.length === 0) {
      if (toggle) {
          toggle.style.display = 'none';
      }
      return;
  }

  var labelEl  = toggle.querySelector('.pricing-card__toggle-label');
  var moreText = toggle.getAttribute('data-label-more') || 'Alle Leistungen zeigen';
  var lessText = toggle.getAttribute('data-label-less') || 'Weniger anzeigen';

  toggle.addEventListener('click', function () {
      var isOpen = toggle.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

      for (var i = 0; i < hidden.length; i++) {
          hidden[i].classList.toggle('is-hidden', !isOpen);
      }

      if (labelEl) {
          labelEl.textContent = isOpen ? lessText : moreText;
      }
  });
}

function initAllPricingCards() {
  var cards = document.querySelectorAll('.pricing-card');
  for (var i = 0; i < cards.length; i++) {
    initPricingCard(cards[i]);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAllPricingCards);
} else {
  initAllPricingCards();
}

// Iframe Custom Events
(function () {
  // Only accept messages from here
  var ALLOWED_ORIGINS = [
    'https://safe2school.blueglass.dev',
    'https://safe2school.ch',
    'https://safe2school.ch/',
    'https://www.safe2school.ch',
    'https://www.safe2school.ch/',
    'https://club.tcs.ch',
    'https://club.tcs.ch/',
  ];

  window.dataLayer = window.dataLayer || [];

  window.addEventListener('message', function (event) {

    // 1. Only accept messages from Tempo-Check-Iframe
    if (ALLOWED_ORIGINS.indexOf(event.origin) === -1) return;

    var data = event.data;

    if (!data || typeof data !== 'object' || data.source !== 'tempo_check') return;

    // 2. Only accept layout events (height)
    if (data.event === 'resize') return;

    // 3. Event + all other fields to dataLayer
    var payload = { source: undefined, event: undefined }; // Platzhalter, gleich überschrieben

    payload = {
      event: data.event,              // GTM-Trigger-Name
      eventData: data,     // z.B. 'speed_checked'
    };

    // get all other data fields (speed, verdict, scenario, ...)
    Object.keys(data).forEach(function (key) {
      if (key === 'source' || key === 'event') return;
      payload[key] = data[key];
    });

    window.dataLayer.push(payload);
  });
})();
